/*
 * @Description: 文件内容
 * @Author: 陈威达
 * @Date: 2024-09-20 14:26:00
 * @LastEditors: 陈威达
 * @LastEditTime: 2024-09-20 14:48:09
 */
import React from 'react'
import styles from './index.scss'
import CustomerImg from '@/common/images/im-customer.png'
import { openIM } from '@/utils/im'
export default function ImCustomer() {
  return (
    <>
      <div className={`${styles['im-cust']}`} onClick={() => openIM()}>
        <img src={CustomerImg} alt='CustomerImg'/>
      </div>
    </>
  )
}
